const swiperBest = new Swiper(".swiper-best", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 24,
  watchSlidesProgress: true,
  //mousewheel: true,

  breakpoints: {
    768: {
      spaceBetween: 38,
    },
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
});
